import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';

import { InputTransformFn, NgxMaskDirective } from 'ngx-mask';

import { IOfficeField } from '@pages/office/models/office-data.model';
import { IInputMaskConfig } from '@pages/office/models/input-mask-config.model';
import { InputMaskHelper } from '../helpers/input-mask.helper';
import { ControlValueAccessorBaseDirective } from '@pages/office/shared/directives/base-control-value-accessor.directive';
import { InputType, InputTypeEnum } from '../models/input-type.models';

// NOTE: The input is wrapped in ControlValueAccessor to address the issue with repeated executions of
// AsyncValidateAndDefaultValidator, since, in the presence of MultipartMask, a new value is set on blur.
@Component({
  selector: 'app-input-custom',
  templateUrl: 'input-custom.component.html',
  styles: `
    :host {
      width: 100%;
    }
  `,
  standalone: true,
  imports: [NgxMaskDirective, NgClass, ReactiveFormsModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputCustomComponent),
      multi: true,
    },
  ],
})
export class InputCustomComponent extends ControlValueAccessorBaseDirective<string> implements OnInit {
  @Input({ required: true }) officeField: IOfficeField;
  @Input({ required: true }) type: InputType;
  @Input() inputTransformFn: InputTransformFn;

  public inputMaskConfig: IInputMaskConfig;

  ngOnInit(): void {
    super.ngOnInit();
    this.inputMaskConfig = this.officeField.InputMaskConfig;
  }

  override writeValue(value: string): void {
    this.innerControl.setValue(value, { emitEvent: false });
  }

  override registerOnChange(fn: (value: string) => void): void {
    this.onChange = (value: string): void => {
      let format = InputMaskHelper.formatMultiPartIfApplicable(value, this.officeField);
      if (this.type === InputTypeEnum.number && (format === '' || isNaN(Number(format)))) {
        format = null;
      }
      fn(format);
      this.innerControl.setValue(format, { emitEvent: false });
    };
  }
}
